function t(t){const n=(new DOMParser).parseFromString(t,"text/html").querySelectorAll('script:not([type="application/ld+json"]):not([type="application/json"])'),o=[];return n.forEach((t=>{o.push(t.innerHTML)})),o.join(";")}export{t as parseJSFromHTML};
//# sourceMappingURL=parseJSFromHTML.js.map
